<div class="content-container">
  <nav class="navbar sticky-top">
    <div class="navbar-brand">
      <h2 *ngIf="user">Welcome, {{user.firstName}}!</h2>
    </div>
    <div style="margin-left: auto; margin-right: 10px;">
      <span *ngIf="unreadNotificationCount > 0" class="custom-badge-lg" style="top: 2px; right: -8px;" [style]="{ 'padding': unreadNotificationCount > 9 ? '0.125rem 0.25rem' : '0' }">{{unreadNotificationCount}}</span>
      <button aria-label="Notifications" type="button" class="btn btn-outline-primary" style="padding: 0.5625rem 0.75rem;" (click)="openConversationNotificationContainer();">
        <fa-icon [icon]="faMobile" size="xl"></fa-icon>
      </button>
    </div>
    <div>
      <span *ngIf="unreadNotificationCount > 0" class="custom-badge-lg" style="top: 2px; right: -8px;" [style]="{ 'padding': unreadNotificationCount > 9 ? '0.125rem 0.25rem' : '0' }">{{unreadNotificationCount}}</span>
      <button aria-label="Notifications" type="button" class="btn btn-outline-primary" style="padding: 0.5625rem 0.75rem;" (click)="openNotificationContainer();">
        <fa-icon [icon]="faBell" size="xl"></fa-icon>
      </button>
    </div>
  </nav>
  <div class="alert alert-warning alert-warning-banner mt-3" role="alert" *ngIf="login?.isInTrial">
    <div class="alert-warning-container">
      <div class="col-sm-12 col-md-8 col-lg-9 col-xl-10">
        <p class="mb-0">Your free trial of Tinsel CRM will expire in <b>{{login?.daysLeft | number: '1.0-0'}} day(s)</b>, at which time you will automatically be charged the price displayed in the Subscriptions settings page. If you enjoy Tinsel CRM and plan to continue using it, then no further action is required. If you are no longer interested in using Tinsel CRM, then you can cancel your subscription before the end of trial to avoid being charged. <b>No refunds will be processed for automatic charges after the free trial expires in {{login?.daysLeft | number: '1.0-0'}} days(s)</b>. To cancel or edit your subscription, please click the “Manage Subscription” button.</p>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-3 col-xl-2 manage-subscription-button" *ngIf="user?.role == 'SUPER'">
        <span><button class="btn btn-primary cursor-pointer" (click)="redirectToSubs()">Manage Subscription</button></span>
      </div>
    </div>
  </div>
  <div class="row gx-2">
    <div [ngClass]="user && (user.hasSalesAccess || !user.hasOwnProperty('hasSalesAccess')) ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4' : 'col-sm-12 col-md-6 col-lg-6 col-xl-6'">
      <app-dashboard-prospects></app-dashboard-prospects>
    </div>
    <div class="pe-0 pe-xl-2 remove-padding" [ngClass]="user && (user.hasSalesAccess || !user.hasOwnProperty('hasSalesAccess')) ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4' : 'col-sm-12 col-md-6 col-lg-6 col-xl-6'">
      <app-dashboard-up-next></app-dashboard-up-next>
    </div>
    <div *ngIf="user && (user.hasSalesAccess || !user.hasOwnProperty('hasSalesAccess'))" class="pe-2 pe-xl-0 remove-padding" [ngClass]="user && (user.hasSalesAccess || !user.hasOwnProperty('hasSalesAccess')) ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4' : 'col-sm-12 col-md-6 col-lg-6 col-xl-6'">
      <app-dashboard-stats></app-dashboard-stats>
    </div>
  </div>
</div>

<!-- Notifications Popover -->
<ng-template *ngIf="!login.isMobile" #popContentNotifications>
  <app-dashboard-notifications></app-dashboard-notifications>
</ng-template>